define('common/js/lib/util/nrkno-embed',['common/js/lib/Serum.Pubsub'], function (Pubsub) {
  /**
   * `require` path for the module that contains the `initialize` function.
   * @type {Record<`nrkno-embed-${string}`,string>}
   */
  var EMBED_TYPE_TO_PATH = {
    'nrkno-embed-nrkno-player': 'common/module/media/nrkno-player/nrkno-player-serum',
    'nrkno-embed-ludo-player': 'common/module/media/Serum.LudoPlayer',
    'nrkno-embed-radio-player': 'common/module/media/Serum.RadioPlayer'
  }

  function initialize() {
    /** @type {NodeListOf<HTMLElement>}  */
    var elements = document.querySelectorAll('.nrkno-embed-initialize');
    elements.forEach(function (element) {
      element.classList.remove('nrkno-embed-initialize');

      var requirePath = EMBED_TYPE_TO_PATH[element.getAttribute('nrkno-embed-type')];
      var initializeProps = element.dataset;
      if (!requirePath) {
        // invalid or missing requirePath
        return;
      }

      requireAndInitialize(requirePath, element, initializeProps)
    })
  }

  /**
   * Require the given path and initialize it
   * @param {string} requirePath
   * @param {Element} element
   * @param {DOMStringMap} initializeProps
   */
  function requireAndInitialize(requirePath, element, initializeProps) {
    require([requirePath], function callback(/** @type {{initialize: (a: Element, b: DOMStringMap) => void }} */ Module) {
      Module.initialize(element, initializeProps);
    })
  }

  document.addEventListener('DOMContentLoaded', initialize);
  Pubsub.subscribe(Pubsub.topics.CHECK_FOR_NRKNO_EMBED, initialize);

  return {
    initialize: initialize
  };
});
